import React, { FunctionComponent } from 'react'
import { MaskedElement } from '@afterpaytouch/integrations/MaskedElement'
import { Text } from '@afterpaytouch/core'
import styles from './style.module.css'

interface TransMaskedTextProps {
  actionName?: string
  testNameSpace?: string
  text: string
}

export const TransMaskedText: FunctionComponent<TransMaskedTextProps> = ({ actionName, testNameSpace, text }) => {
  return (
    <div className={styles.wrapper} data-testid='trans-masked-text-wrapper'>
      <MaskedElement actionName={actionName} testNameSpace={testNameSpace}>
        <Text renderAs='span'>{text}</Text>
      </MaskedElement>
    </div>
  )
}
